import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../context/AnalyticsContext';

/**
 * Hook that tracks page views when the route changes.
 * Only tracks if user has given analytics consent.
 */
export function usePageTracking() {
    const location = useLocation();
    const { trackPage, consentStatus } = useAnalytics();
    const lastTrackedPath = useRef(null);

    useEffect(() => {
        // Don't track if no consent
        if (consentStatus !== 'accepted') {
            return;
        }

        // Debounce: don't track same path twice in quick succession
        if (lastTrackedPath.current === location.pathname) {
            return;
        }

        // Small delay to batch rapid navigations
        const timer = setTimeout(() => {
            lastTrackedPath.current = location.pathname;
            trackPage(location.pathname);
        }, 300);

        return () => clearTimeout(timer);
    }, [location.pathname, consentStatus, trackPage]);
}

export default usePageTracking;
